import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import doorbell from '../../sounds/doorbell.wav'
import { shufflaa } from '../../utils/randomize'
import { data } from './data/data_01_Rappu'
import kuva from './images/ovi_raollaan_300x430.png'


const Scene_01_Rappu = ({ scoreHandler, visibilityHandler, soundsOn, timeHandler }) => {


    let lista = null
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])
    const [optiot2Populoitu, setOptiot2Populoitu] = useState(false)
    const [klikattuOptio, setKlikattuOptio] = useState('')

    const [time1, setTime1] = useState(0)

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playDoorbell] = useSound(doorbell);


    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOptiot1(data.optiot)
        setTeksti(data.kysymysteksti)
        setTime1(Date.now())
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {
            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])


    const klikattuVaihtoehtoa = (optio) => {

        //jos tarvetta modata dataan kovakoodattua pisteytystä niin sen voi tehdä tässä (esim. jos ripeys/ streak tms vaikuttaa )

        // optio = pisteytys(optio)

        if (optio.valinta == 'A_ovikello' && soundsOn) {
            playDoorbell()
        }

        if (soundsOn) {

            if (Number(optio.pisteet) > 0) {
                // playCorrectAnswer()
            }
            else {
                playWrongAnswer()
            }

        }

        timeHandler(time1)

        //välitetään scenepohja-välikomponentille optioon kovakoodattu palaute 
        scoreHandler(optio, data.scene, data.maxp)


        visibilityHandler(optio.valinta)
    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>

                <span className='clickable'
                    onClick={() => klikattuVaihtoehtoa(optio)}

                >
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (

        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>
                <img src={kuva} alt='kuva' />
            </div>


            <div id='question'>
                <h4>{(teksti != null && teksti != "") ? teksti : null}</h4>


            </div>

            <div id='actions'>
                <ul>
                    {lista}
                </ul>
            </div>
        </div>
    )

}

export default Scene_01_Rappu